import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import SectionHeading from "../SectionHeading";
import { TESTIMONIALS } from "../../data/site";

export const Testimonials = () => {
  return (
    <section data-testid="testimonials-section" className="relative py-24 md:py-32 bg-navy-deep">
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <SectionHeading
            overline="Trust"
            title="What partners say"
            subtitle="Relationships built on transparency and delivery."
          />
          <span className="font-mono text-xs text-slate-500 shrink-0">* Placeholder testimonials</span>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <motion.blockquote
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
              data-testid={`testimonial-${i}`}
              className="glass rounded-3xl p-8 flex flex-col h-full"
            >
              <Quote size={32} className="text-brand-orange/60 mb-5" />
              <p className="text-slate-200 leading-relaxed flex-1">"{t.quote}"</p>
              <footer className="mt-6 pt-6 border-t border-white/10">
                <p className="font-head font-semibold text-white">{t.name}</p>
                <p className="text-slate-500 text-sm">{t.role}</p>
              </footer>
            </motion.blockquote>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
